
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"9","height":"14","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#FFF","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M1.31 0c.337 0 .673.129.93.388l5.54 5.601a1.308 1.308 0 1 1-1.86 1.842L.378 2.229A1.308 1.308 0 0 1 1.309 0"}}),_c('path',{attrs:{"d":"M6.85 5.601a1.31 1.31 0 0 1 .926 2.235l-5.54 5.54a1.31 1.31 0 0 1-1.852-1.852l5.54-5.54a1.31 1.31 0 0 1 .925-.383"}})])])
          )
        }
      }
    